import { useDispatch, useSelector } from 'react-redux';
import {
  getAllHubsRouting,
  setCloseNotifMasterHub,
} from '../../../../../../store/Routing/hubs';
import CustomNotifSuccess from '../../../../../../components/shared/CustomNotifSuccess';

const NotifHub = () => {
  const dispatch = useDispatch();
  const { keyNotif, textNotif } = useSelector(getAllHubsRouting);

  const keys = ['addHubs', 'editHubs', 'deleteHubs', 'nextAdd', 'addSubHub'];

  return (
    <>
      {keys.map((key, index) => (
        <CustomNotifSuccess
          text={textNotif}
          open={keyNotif === key}
          keys={keyNotif}
          onClose={() => {
            dispatch(setCloseNotifMasterHub());
          }}
          key={index}
          sx={{
            background: key === 'nextAdd' ? '#A33A3A' : '',
            color: key === 'nextAdd' ? '#FFF' : '',
          }}
        />
      ))}
    </>
  );
};
export default NotifHub;
